import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import star from 'assets/images/smStar.svg';
import PickUp from 'components/pickAndDrop/PickUp';
import AssignedDriver from 'pages/rideTrack/AssignDriver';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import { getTrip } from 'redux/actions/UserTrip';
import { useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from 'components/loader/Loader';

function FeedbackBrief() {
  const dispatch = useDispatch();
  const {state} = useLocation();
  const id = state?.tripId;
  const type = state?.type;
  // const [searchParams, setSearchParams] = useSearchParams();
  // const id = searchParams.get('tripId');
  // const type = searchParams.get('type');
  const tableData = useSelector((state) => state?.userTrip?.userTrip?.data);
  const loader = useSelector((state) => state?.userTrip?.loading);
  const filterData = {
    id: id
  }

  useEffect(() => {
    dispatch(getTrip(filterData));
  }, []);

  const breadcrumbPaths = [
    { name: 'Feedback', url: '/feedback', className:'colorGrey fontSemi' ,},
    { name: type, url: '/', className:'colorBlue fontSemi' ,},
  ];

  return (
    <div>
      <CommonBreadCrumb paths={breadcrumbPaths}/>
      {loader? 
        <Loader/> 
        :
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="start"
        >
          {/* 1st Section */}
          <Grid item container sm={12} md={8} className="paddingTRB20">
            <Grid
              item
              container
              sm={12}
              md={12}
              className="padding20 borderStyle"
            >
            <Grid
              item
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item sm={12} md={7}>
                <p className="font14 fontNormal colorGrey">
                  {(type === 'Driver' ? 'Driver' : 'Customer')+' Rating :'}
                  <span className="marginInline10 font16 fontSemi colorBlack">
                    <img src={star} alt="star" className="feedbackStar" /> {tableData?.Rating?.rating}
                  </span>
                  {/* <span className="marginInline10 colorBlack">Excellent</span>
                  <span className="marginInline10 colorBlack">Friendly</span>
                  <span className="marginInline10 colorBlack">Very Good</span> */}
                </p>
                <div className="alignItem marginTop45">
                  <h1 className="font14 fontNormal colorGrey">
                    {(tableData?.Rating?.type ? tableData?.Rating?.type : type === 'Driver' ? 'Driver' : 'Customer')+' Feedback : '}
                  </h1>
                  <p className="font16 fontSemi ">
                    {tableData?.Rating?.tags}
                  </p>
                </div>
              </Grid>
              <Grid item md={4} sm={12}>
                <p className="font14 fontNormal colorGrey">Customer Details :</p>
                <h1 className="font18 fontBold">{tableData?.DemandProfile?.name}</h1>
                {tableData?.DemandProfile?.location && tableData?.DemandProfile?.location !== null && <p className="font14 fontNormal colorGrey">
                  {tableData?.DemandProfile?.location}
                </p>}
                {tableData?.DemandProfile?.mobile && tableData?.DemandProfile?.mobile !== null && <p className="font14 fontNormal colorGrey">
                  {tableData?.DemandProfile?.mobile}
                </p>}
                <h1 className="font16 fontMedium">{tableData?.price ? ('₹'+tableData?.price) : ""}</h1>
              </Grid>
            </Grid>
            <Grid item xs={12} className="feedbackBrief">
              <PickUp tableData={tableData}/>
            </Grid>
          </Grid>
          </Grid>

          {/* 2nd section */}
          <Grid item container sm={12} md={4} className="padding20">
            <Grid item container sm={12} md={12} className="borderStyle">
              <AssignedDriver tableData={tableData} />
            </Grid>
          </Grid>
        </Grid>
      }
    </div>
  );
}

export default FeedbackBrief;
